/** @fileoverview Shared native checkbox and radio choices (`AppCheckbox`, `AppRadioButton`). They keep PrimeReact's props and `{ originalEvent, checked, value }` change event, so forms moved off PrimeReact kept their handlers. Parents own checked state and persistence. */
import React from 'react';

export function Checkbox({ inputId, id, checked, onChange, value, binary, ...props }) {
  return <input {...props} id={inputId || id} type="checkbox" checked={Boolean(checked)} value={value}
    onChange={event => onChange?.({ originalEvent: event, target: event.target, checked: event.target.checked, value })}
    style={{ accentColor: 'var(--primary-color)', ...props.style }} />;
}

export function RadioButton({ inputId, id, checked, onChange, value, ...props }) {
  return <input {...props} id={inputId || id} type="radio" checked={Boolean(checked)} value={value}
    onChange={event => onChange?.({ originalEvent: event, target: event.target, value })}
    style={{ accentColor: 'var(--primary-color)', ...props.style }} />;
}

export default Checkbox;
